import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ReactComponent as BurgerMenuIcon } from "src/assets/static/images/header/burger-menu.svg";
import { ReactComponent as DesktopLogoIcon } from "src/assets/static/images/header/desktop-logo.svg";
import { ReactComponent as DesktopLogoEngIcon } from "src/assets/static/images/header/desktop-logo-eng.svg";
import { ReactComponent as UserButtonIcon } from "src/assets/static/images/header/header-profile-button.svg";
import { ReactComponent as MobileLogoIcon } from "src/assets/static/images/header/mobile-logo.svg";
import { ReactComponent as MobileLogoEngIcon } from "src/assets/static/images/header/mobile-logo-eng.svg";
import { ReactComponent as XCloseIcon } from "src/assets/static/images/header/close-x.svg";
import { ReactComponent as DownArrowSmallIcon } from "src/assets/static/images/header/angle-right-small.svg";
import DesktopMenuOptions from "./desktopMenuOptions";
import SidebarToggle from "./SidebarToggle";
import useFormatById from "src/hooks/utils/useFormatById";
import LanguageSwitcher from "./languageSwitcher";

const Header = () => {
  const lang = useSelector((state) => state.common.lang);
  const [activeMenu, setActiveMenu] = useState(null);
  const [openSideBar, setOpenSideBar] = useState(false);
  const dropdownRef = useRef(null);
  const firstMenuRef = useRef(null);
  const secondMenuRef = useRef(null);
  const sideBarCloseRef = useRef(null);
  const f = useFormatById();

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !(
          firstMenuRef.current && firstMenuRef.current.contains(event.target)
        ) &&
        !(secondMenuRef.current && secondMenuRef.current.contains(event.target))
      ) {
        setActiveMenu(null); // Close menu
      }

      if (
        sideBarCloseRef.current &&
        !sideBarCloseRef.current.contains(event.target)
      ) {
        setOpenSideBar(false); // Close sidebar
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleMenuClick = (menuId) => {
    if (activeMenu === menuId) {
      setActiveMenu(null);
    } else {
      setActiveMenu(menuId);
    }
  };

  const closeMenu = () => {
    setActiveMenu(null);
  };

  return (
    <>
      <div className="header-mobile-height"></div>
      <header>
        <div className="header-content">
          {openSideBar ? (
            <XCloseIcon
              className="burger-menu-icon"
              onClick={() => setOpenSideBar(false)}
            />
          ) : (
            <BurgerMenuIcon
              className="burger-menu-icon"
              onClick={() => setOpenSideBar(true)}
            />
          )}

          <Link to={"/home/" + lang}>
            {lang === "ge" ? (
              <DesktopLogoIcon className="logo" />
            ) : (
              <DesktopLogoEngIcon className="logo" />
            )}
          </Link>

          <Link to={"/home/" + lang}>
            {lang === "ge" ? (
              <MobileLogoIcon className="logo-mobile" />
            ) : (
              <MobileLogoEngIcon className="logo-mobile" />
            )}
          </Link>

          <nav className="nav">
            <div
              ref={firstMenuRef}
              className={`item ${activeMenu === 1 ? "active" : ""}`}
              onClick={() => handleMenuClick(1)}
            >
              {f("topbar.InsuranceProducts")} <DownArrowSmallIcon />
            </div>
            <div
              ref={secondMenuRef}
              className={`item ${activeMenu === 2 ? "active" : ""}`}
              onClick={() => handleMenuClick(2)}
            >
              {f("topbar.OnlineServices")} <DownArrowSmallIcon />
            </div>
            <Link
              className="item"
              to={`${process.env.REACT_APP_CLIENT_MAIN_URL}/home/${lang}`}
              onClick={() => setActiveMenu(null)}
            >
              {f("main.offers")}
            </Link>
            <Link
              className="item"
              to={`${process.env.REACT_APP_CLIENT_MAIN_URL}/blogs/${lang}`}
              onClick={() => setActiveMenu(null)}
            >
              {f("topbar.news")}
            </Link>
          </nav>

          <div className="user-icon-wrapper">
            <LanguageSwitcher />
            <a
              target="_blank"
              href={`${process.env.REACT_APP_IMEDIL_LINK}${lang}`}
            >
              <UserButtonIcon className="user-button-Icon" />
            </a>
          </div>

          {/* dropdown menu */}
          <DesktopMenuOptions
            dropdownRef={dropdownRef}
            activeMenu={activeMenu}
            closeMenu={() => closeMenu()}
          />
        </div>
      </header>

      <SidebarToggle
        isOpen={openSideBar}
        setOpenSideBar={setOpenSideBar}
        sideBarClose={sideBarCloseRef}
      />
    </>
  );
};

export default Header;
